<div class="container">
  <div class="diagram-indicator" [ngClass]="{'diagram-indicator-hidden': !(hasDiagram$ | async)}"></div>
  <button mat-icon-button (click)="onClick()">
    <mat-icon [svgIcon]="'whiteboard_stylus'"></mat-icon>
  </button>
</div>
